import { gql } from '@apollo/client'

export const VALIDATE_REGISTRATION = gql`
    mutation validateRegistration($customerID: String!, $registrationKey: String!, $pw: String!) {
        validateRegistration(customerID: $customerID, registrationKey: $registrationKey, pw: $pw)
    }
`
